const initState = () => ({
  outgoingConsignments:{
    new:{
      items: [],
      totalItems: 0,
    },
    processing:{
      items: [],
      totalItems: 0,
    },
    closed:{
      items: [],
      totalItems: 0,
    },
    all:{
      items: []
    }
  }
})

export const state = initState
export const getters = {
  getOptions: (state) => (type) =>{
    return state.outgoingConsignments[type].options
  }
}
export const mutations = {
  setNewOutgoingConsignment(state, {newOutgoingConsignments}) {
    if(newOutgoingConsignments) {
      state.outgoingConsignments.new.items = newOutgoingConsignments
    }
  },
  setNewTotalItemCount(state, {itemCount}) {
    if(itemCount) {
      state.outgoingConsignments.new.totalItems = itemCount
    }
  },
  setProcessingOutgoingConsignment(state, {processingOutgoingConsignments}) {
    if(processingOutgoingConsignments) {
      state.outgoingConsignments.processing.items = processingOutgoingConsignments
    }
  },
  setProcessingTotalItemCount(state, {itemCount}) {
    if(itemCount) {
      state.outgoingConsignments.processing.totalItems = itemCount
    }
  },
  setClosedOutgoingConsignment(state, {closedOutgoingConsignments}) {
    if(closedOutgoingConsignments) {
      state.outgoingConsignments.closed.items = closedOutgoingConsignments
    }
  },
  setClosedTotalItemCount(state, {itemCount}) {
    if(itemCount) {
      state.outgoingConsignments.closed.totalItems = itemCount
    }
  },
}

export const actions = {
  async getOutgoingConsignments({commit}, {outgoingConsignment, filters}) {
    const outgoingConsignmentsResult = await this.$axios.$get(
      '/OutgoingConsignments/outgoingConsignments' +
      '?pageSize=' + (outgoingConsignment.pageSize ?? 10) +
      '&pageNo=' + (outgoingConsignment.page ?? 0) +
      (outgoingConsignment.status ? ('&OrderStatusCode='+outgoingConsignment.status) : '') +
      filters
    )
    if(outgoingConsignmentsResult){
      if(!outgoingConsignmentsResult.hasErrors) {
        switch(outgoingConsignment.type){
          case 'new':
            commit('setNewOutgoingConsignment', {newOutgoingConsignments: outgoingConsignmentsResult.items})
            commit('setNewTotalItemCount', {itemCount: outgoingConsignmentsResult.pagingData.itemCount})
            break
          case 'processing':
            commit('setProcessingOutgoingConsignment', {processingOutgoingConsignments: outgoingConsignmentsResult.items})
            commit('setProcessingTotalItemCount', {itemCount: outgoingConsignmentsResult.pagingData.itemCount})
            break
          case 'closed':
            commit('setClosedOutgoingConsignment', {closedOutgoingConsignments: outgoingConsignmentsResult.items})
            commit('setClosedTotalItemCount', {itemCount: outgoingConsignmentsResult.pagingData.itemCount})
            break
        }

      }else{
        outgoingConsignmentsResult.reject('Error while getting outgoingConsignments!')
      }
    }
  },
  async getOutgoingConsignmentItems({}, consignmentId){
    let consignmentItems = [];
    try{
      const result = await this.$axios.get( `OutgoingConsignments/${consignmentId}/items`);

      if(result?.data?.apiMessages.hasErrors){
        this.$toast.error('Error while getting outgoing consignment items')
      }
      else if(result.data?.value?.length) {
        consignmentItems = result.data.value;
      }
    }
    catch(e){
      this.$toast.error('Error while getting outgoing consignment items')
    }
    return consignmentItems;
  },
}
